import React, { useState, useContext } from "react";
import { Formik, Field, Form } from "formik";
import {
  Box,
  Input,
  FormControl,
  FormErrorMessage,
  Button,
  Flex,
} from "@chakra-ui/react";
import { logIn } from "../../Utils/auth";
import { UsersContext } from "../Context/UsersContext";
import { useHistory } from "react-router-dom";

const LoginForm = () => {
  const { getCurrentUser } = useContext(UsersContext);
  const [error, setError] = useState({});
  const history = useHistory();

  const handleSubmit = (values, { setSubmitting }) => {
    logIn(values)
      .then((res) => {
        setError({});
        getCurrentUser(res.token)
          .then(() => {
            history.push("/");
          })
          .catch((e) => {
            console.log(e, "error");
            setSubmitting(false);
          });
      })
      .catch((e) => {
        setError(e.response.data);
        setSubmitting(false);
      });
  };

  const validateEmail = (value) => {
    if (!value) {
      return "Ingrese un email.";
    }
    const regexEmail =
      /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    if (!value.match(regexEmail)) {
      return "Ingrese un email válido.";
    }
  };
  return (
    <Formik initialValues={{ email: "", pass: "" }} onSubmit={handleSubmit}>
      {(props) => (
        <Form>
          <Flex flexDirection="column">
            <Box p="3">
              <Field name="email" validate={validateEmail}>
                {({ field, form }) => (
                  <FormControl
                    isInvalid={form.errors.email && form.touched.email}
                  >
                    <Input
                      {...field}
                      /* type="email" */
                      id="email"
                      placeholder="Ingrese su email"
                    />
                    <FormErrorMessage>{form.errors.email}</FormErrorMessage>
                  </FormControl>
                )}
              </Field>
            </Box>
            <Box Box p="3">
              <Field name="pass" m="1rem">
                {({ field, form }) => (
                  <FormControl
                    isInvalid={form.errors.pass && form.touched.pass}
                  >
                    <Input
                      {...field}
                      id="pass"
                      type="password"
                      placeholder="Ingrese su contraseña"
                    />
                    <FormErrorMessage>{form.errors.pass}</FormErrorMessage>
                  </FormControl>
                )}
              </Field>
            </Box>
            <Box p="3">
              <Box color="red.500">{error.message}</Box>
              <Button
                w="100%"
                colorScheme="teal"
                isLoading={props.isSubmitting}
                type="submit"
              >
                Entrar
              </Button>
            </Box>
          </Flex>
        </Form>
      )}
    </Formik>
  );
};

export default LoginForm;
